import { IconCollection } from "components/Icon/IconCollection";
import IconButton from "components/IconButton/IconButton";
import "./MaximizeHandler.scss";

export const MaximizeHandler = ({ maximize }: { maximize: () => void }) => (
    <div className="maximizeHandle">
        <IconButton icon={IconCollection.arrowExpand} onClick={maximize} />
    </div>
);
